import React, { useEffect } from "react";
// import "./ChildSafety.scss"; 

function ChildSafety() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <div className="policy-container">
            <div className="container">
                <h2>LoveHappiness – Child Safety & Community Standards</h2>
                <p><strong>Last updated:</strong> 8 December 2025</p>

                <p>
                    LoveHappiness (“<strong>LoveHappiness</strong>”, “<strong>Love Happiness</strong>”,
                    “<strong>we</strong>”, “<strong>us</strong>”, “<strong>our</strong>”) is a dating and
                    connection app designed <strong>for adults aged 18 and over only</strong>. We are committed
                    to keeping our platform safe and to preventing any form of child sexual abuse and exploitation.
                </p>

                <p>
                    These Child Safety & Community Standards apply to everyone who uses the LoveHappiness app and
                    website <a href="https://lovehappiness.co.uk">https://lovehappiness.co.uk</a>.
                </p>

                <p>By using LoveHappiness, you agree to follow these standards.</p>


                {/* Section 1 */}
                <h3>1. 18+ Only</h3>
                <ul>
                    <li>LoveHappiness is <strong>strictly for adults aged 18 and over</strong>.</li>
                    <li>You must be at least 18 years old to create an account or interact with users.</li>
                    <li>Creating an account for anyone under 18 is not allowed.</li>
                </ul>
                <p>
                    If we believe an account belongs to someone under 18, we may suspend or permanently remove it.
                </p>


                {/* Section 2 */}
                <h3>2. Zero Tolerance for CSAE and CSAM</h3>
                <p>We do not tolerate:</p>
                <ul>
                    <li>Child Sexual Abuse & Exploitation (CSAE)</li>
                    <li>Child Sexual Abuse Material (CSAM)</li>
                </ul>

                <p>Strictly prohibited:</p>
                <ul>
                    <li>Any sexual content involving or appearing to involve minors.</li>
                    <li>Grooming or attempts to engage with minors sexually.</li>
                    <li>Discussing, joking about, or fantasising about sexual acts involving minors.</li>
                    <li>Searching for, sharing, or distributing CSAM.</li>
                </ul>

                <p>
                    Violations may lead to permanent bans and reporting to law enforcement or child protection authorities.
                </p>


                {/* Section 3 */}
                <h3>3. Other Prohibited Behaviour</h3>
                <ul>
                    <li>Harassment, bullying, or threats.</li>
                    <li>Hate speech or targeting users based on protected characteristics.</li>
                    <li>Non-consensual or exploitative sexual content.</li>
                    <li>Coercion, blackmail, or extortion.</li>
                    <li>Impersonation or creating fake profiles.</li>
                    <li>
                        Moving conversations off the platform to exploit, scam, or abuse someone.
                    </li>
                </ul>


                {/* Section 4 */}
                <h3>4. How to Report a Safety Concern</h3>
                <h4>4.1 In-app reporting</h4>
                <p>You can:</p>
                <ul>
                    <li>Use the “Report” option on profiles or chats.</li>
                    <li>Go to <strong>Settings → Help & Safety → Contact Support / Report a Concern</strong>.</li>
                </ul>
                <p>Please include details like usernames, time, description, and screenshots if possible.</p>

                <h4>4.2 Email</h4>
                <p>You can email:</p>
                <p><strong>Child safety concerns:</strong><a href="mailto:info@lovehappiness.co.uk">info@lovehappiness.co.uk</a></p>
                <p><strong>Subject suggestion:</strong> “URGENT – Child Safety Concern”</p>


                {/* Section 5 */}
                <h3>5. How We Respond to Child Safety Issues</h3>
                <ul>
                    <li>Review reports with priority.</li>
                    <li>Restrict or suspend accounts during investigations.</li>
                    <li>Remove violating or illegal content.</li>
                    <li>Permanently ban offenders.</li>
                    <li>Report confirmed cases to law enforcement or child protection agencies.</li>
                </ul>


                {/* Section 6 */}
                <h3>6. Our Commitment and Legal Compliance</h3>
                <ul>
                    <li>Follow child protection, online safety, and data protection laws.</li>
                    <li>Cooperate with law enforcement where appropriate.</li>
                    <li>Prevent, detect, and respond to CSAE and CSAM.</li>
                    <li>Train staff and partners on safety standards.</li>
                </ul>


                {/* Section 7 */}
                <h3>7. Child Safety Point of Contact</h3>
                <p><strong>Child Safety Officer – LoveHappiness</strong></p>
                <p>Email: <a href="mailto:info@lovehappiness.co.uk">info@lovehappiness.co.uk</a></p>


                {/* Section 8 */}
                <h3>8. Relationship with Our Other Policies</h3>
                <p>These standards work alongside our:</p>
                <ul>
                    <li>Privacy Policy</li>
                    <li>Terms of Use / Terms & Conditions</li>
                    <li>Other in-app guidelines</li>
                </ul>


                {/* Section 9 */}
                <h3>9. Changes to These Standards</h3>
                <p>
                    We may update these standards due to legal changes, safety improvements, or feedback. We will
                    update the “Last updated” date and notify users when required.
                </p>

                <p>If you have questions, contact: <a href="mailto:info@lovehappiness.co.uk">info@lovehappiness.co.uk</a></p>
            </div>
        </div>
    );
}

export default ChildSafety;
